import PropTypes from 'prop-types';
import {SymbolicDate} from './enums';

/**
 * Typ property filtru.
 */
export const filterPropType = PropTypes.shape({
    date: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.oneOf(Object.keys(SymbolicDate))
    ]),
    dateFrom: PropTypes.instanceOf(Date),
    dateTo: PropTypes.instanceOf(Date),
});

/**
 * Typy properties společné pro všechny mapové komponenty.
 */
export const commonPropTypes = {
    area: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
    serverUrl: PropTypes.string,
    queryParams: PropTypes.object,
    contextParams: PropTypes.object,
    dateFilterItems: PropTypes.array,
    onEvent: PropTypes.func,
};

/**
 * Výchozí hodnoty properties společné pro všechny mapové komponenty.
 */
export const commonDefaultProps = {
    serverUrl: window.MAPIO_URL,
};
